import { PropsWithChildren } from 'react';

import { FontTitleProps } from './model';
import { View } from './view';

export const FontTitle = (props: PropsWithChildren<FontTitleProps>) => {
    return <View {...props} />;
};
